import axios from "axios";
import { API_BASE_URL } from "../config";

// Isolated client — global axios (api/cars.js) pops SweetAlert on every error,
// which breaks the guest Build Your Car flow.
const client = axios.create({ baseURL: API_BASE_URL });

// Catalog reads are public (auth.optional on the backend). Submit still needs a
// real session token.
function optionalAuthConfig() {
  const token = localStorage.getItem("token");
  return token ? { headers: { authtoken: `${token}` } } : {};
}

function requireAuthConfig() {
  const token = localStorage.getItem("token");
  if (!token) {
    const err = new Error("Authentication required");
    err.code = "AUTH_REQUIRED";
    throw err;
  }
  return { headers: { authtoken: `${token}` } };
}

function unwrap(response) {
  return response?.data?.data ?? [];
}

// Public twin of /product/getCompanies (which is auth.isLoggedIn).
export async function fetchMakes() {
  return unwrap(await client.get(`/product/getCarMaker`, optionalAuthConfig()));
}

export async function fetchModels(companyId) {
  return unwrap(
    await client.get(`/series/getSeriesByCompanyId/${companyId}`, optionalAuthConfig())
  );
}

export async function fetchTrims(companyId, seriesId) {
  let endpoint = `/product/getCarsByCompanyId/${companyId}`;
  if (seriesId) endpoint += `?seriesId=${seriesId}`;
  return unwrap(await client.get(endpoint, optionalAuthConfig()));
}

export async function fetchCar(carId) {
  return unwrap(await client.get(`/product/getCarById/${carId}`, optionalAuthConfig()));
}

export async function submitQuickBid(payload) {
  const response = await client.post(`/bid/submit-bid`, payload, requireAuthConfig());
  return response?.data ?? null;
}

export default { fetchMakes, fetchModels, fetchTrims, fetchCar, submitQuickBid };
